(function () {
  'use strict';
  
  /**
   * @ngdoc service
   * @name drug.factory:Drug
   *
   * @description
   *
   */
  angular
    .module('vcdrug')
    .factory('Drug', Drug);
  
  
  Drug.$inject = ['restmod'];
  function Drug(restmod) {
    return restmod.model('/routes/patdrugs').mix({
      created: {
        init: function () {
          return moment().toISOString();
        }
      },
      drugs: {init: []},
      active: {init: true},
      $extend: {
        Model: {
          $searchahead: function (_params) {
            return this.$collection().$decorate({
              'before-request': function (_req) {
                _req.method = 'GET';
                _req.url = '/routes/patdrugs/searchahead';
              }
            }, function () {
              return this.$fetch(_params);
            });
          },
          $searchBy: function (key, val) {
            let realquery = {};
            realquery[key] = val;
            return this.$search(realquery);
          }
        } // Model
      }// extend
    });
  }
  
// klammerfriedhof
}());
